module.exports = {
  google: {
    API_KEY: "",
    CLIENT_ID: "",
    SECRET: "",
  },
  facebook: {
    APP_ID: "",
  },
  uiConsts: {
    menuIconHeight: 40, // scss-cmd-2
    subMenuIconHeight: 40, // scss-cmd-2
  },
  urls: {
    apiDocUrl: "https://apidocs.lystface.com/",
    lfTermsCnds: "https://www.lystface.com/terms-conditions/",
    lfPrivacy: "https://www.lystface.com/privacy/",
    lfPricing: "https://www.lystface.com/pricing/",
    lfLanding: "https://www.lystface.com/",
    apiDocEnrollUrl: "https://apidocs.lystface.com/#21d04eb2-d4b6-4af3-931f-a5d96cde4b5b",
    apiDocVerifyUrl: "https://apidocs.lystface.com/#8d9068b5-70f3-4cde-bb36-1ca9b980b3dc",
    apiDocRecognizeUrl: "https://apidocs.lystface.com/#2c6dac7a-f132-4da7-a9a9-a9fb0ed7280e"
  },
  devUrls: {
    apiDocUrl: "https://apidocs.lystface.com/",
    lfTermsCnds: "https://lystface.gigglly.com/lystface-landing-website/terms-conditions/",
    lfPrivacy: "https://lystface.gigglly.com/lystface-landing-website/privacy/",
    lfPricing: "https://lystface.gigglly.com/lystface-api-website/pricing/",
    lfLanding: "https://lystface.gigglly.com/lystface-landing-website/",

  },
  messages: {
    supportEmail: "support@lystloc.com"
  },
  imageValidation: {
    maxFileSize: 1,//in MB
    allowedFormats: ['image/jpeg', 'image/png', 'image/jpg']
  },
  usageDurationTypes: [
    { label: 'per hour', value: 'hour' },
    { label: 'per day', value: 'day' },
    { label: 'per month', value: 'month' },


  ],
  timeDurationTypes: [
    { label: '24hrs', value: '24h' },
    { label: '7 days', value: '7d' },
    { label: '30 days', value: '30d' },
    { label: '12 months', value: '12m' },],
  legendsColors: {
    'Enroll': '#A6830F',
    'Remove Subject': '#A83553',
    'Recognize': '#0069B0',
    'Verify': '#EC8946',
    'Compare': '#6FBFBD',
    'Gallery Subjects List': '#916CD8',
    'Gallery List': '#D35774',
    'Remove Gallery': '#6E97ED',
    'Total Transaction': '#4C3AB1',
    'View Subject': '#76CF80',
    'Delete Face': '#FF7777'
  },
  planIds: {
    enterprise: "PL-MEE",
    basic: "PL-MBC"

  }

}